/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import { _API } from "../../../modules/utils";
import "./EventMedia.css";

const MEDIA_CARD_SAMPLE = [
  {
    media_idx: "sample-live-recording",
    video_title: "1일차 키노트 녹화본",
    type_label: "라이브 녹화본",
    version_kind_label: "원본",
    edit_version: null,
    card_state: "세션 연결됨",
    linked_session_count: 1,
    linked_sessions_summary: ["오프닝 세션"],
    thumbnail_state: "ready",
    thumbnail_state_label: "ready",
  },
  {
    media_idx: "sample-ondemand-upload",
    video_title: "제품 데모 업로드",
    type_label: "온디맨드 업로드",
    version_kind_label: "편집본",
    edit_version: "v1",
    card_state: "draft",
    linked_session_count: 0,
    linked_sessions_summary: [],
    thumbnail_state: "pending",
    thumbnail_state_label: "pending",
  },
  {
    media_idx: "sample-thumbnail-failed",
    video_title: "다시보기 업로드",
    type_label: "온디맨드 업로드",
    version_kind_label: "원본",
    edit_version: null,
    card_state: "past",
    linked_session_count: 0,
    linked_sessions_summary: [],
    thumbnail_state: "failed",
    thumbnail_state_label: "failed",
  },
];

const THUMBNAIL_STATES = ["pending", "processing", "ready", "failed", "manual"];

const TYPE_FILTERS = [
  { value: "", label: "전체 타입" },
  { value: "LIVE_RECORDING", label: "라이브 녹화본" },
  { value: "ON_DEMAND_UPLOAD", label: "온디맨드 업로드" },
];

const CONNECTION_FILTERS = [
  { value: "", label: "전체 연결" },
  { value: "LINKED", label: "연결됨" },
  { value: "LINKED_MULTI", label: "N개 연결" },
  { value: "UNLINKED", label: "미연결" },
];

const CARD_STATE_FILTERS = [
  { value: "", label: "전체 상태" },
  { value: "published", label: "published" },
  { value: "draft", label: "draft" },
  { value: "past", label: "past" },
  { value: "session_unmatched", label: "세션 미매칭" },
];

const NCLOUD_RECORDING_PAGE_SIZE = 20;

export default function EventMediaLibrary(props) {
  const eventIdx = props?.match?.params?.eventIdx;
  const query = new URLSearchParams(props?.location?.search || "");
  const siteIdx = query.get("siteIdx") || props?.match?.params?.siteIdx || "";
  const [type, setType] = useState("");
  const [connection, setConnection] = useState("");
  const [cardState, setCardState] = useState("");
  const [keyword, setKeyword] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mediaError, setMediaError] = useState("");
  const [channels, setChannels] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [selectedChannelId, setSelectedChannelId] = useState("");
  const [selectedSessionIdx, setSelectedSessionIdx] = useState("");
  const [recordings, setRecordings] = useState([]);
  const [recordPage, setRecordPage] = useState(0);
  const [recordingLoading, setRecordingLoading] = useState(false);
  const [importingKey, setImportingKey] = useState("");
  const [importMessage, setImportMessage] = useState("");
  const [matchSelections, setMatchSelections] = useState({});
  const [matchingKey, setMatchingKey] = useState("");
  const [matchMessage, setMatchMessage] = useState("");

  const buildScope = () => ({
    ...(siteIdx && { siteIdx }),
  });

  const loadMedia = async () => {
    if (!eventIdx) return;
    setLoading(true);
    setMediaError("");
    try {
      const res = await _API.get({
        path: `/v1/events/${eventIdx}/media`,
        data: {
          ...buildScope(),
          ...(type && { type }),
          ...(connection && { connection }),
          ...(cardState && { card_state: cardState }),
          ...(keyword && { q: keyword }),
        },
        isNoErrorNotify: true,
      });
      setItems(res?.data?.items || []);
    } catch (error) {
      setItems([]);
      setMediaError(error?.message || "미디어 목록을 불러오지 못했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const loadImportOptions = async () => {
    if (!eventIdx) return;
    try {
      const res = await _API.post({
        path: `/v1/events/${eventIdx}/media/ncloud-import/options`,
        data: buildScope(),
        isNoErrorNotify: true,
      });
      const nextChannels = res?.data?.channels || [];
      const nextSessions = res?.data?.sessions || [];
      setChannels(nextChannels);
      setSessions(nextSessions);
      setSelectedChannelId((current) => current || nextChannels[0]?.ncloud_channel_id || "");
      setSelectedSessionIdx((current) => current || nextSessions[0]?.session_idx || "");
    } catch (error) {
      setChannels([]);
      setSessions([]);
      setImportMessage(error?.message || "NCloud 가져오기 옵션을 불러오지 못했습니다.");
    }
  };

  const loadRecordings = async (page = recordPage) => {
    if (!selectedChannelId) return;
    const nextPage = Math.max(0, page);
    setRecordingLoading(true);
    setImportMessage("");
    try {
      const res = await _API.post({
        path: `/v1/events/${eventIdx}/media/ncloud-import/records`,
        data: {
          ...buildScope(),
          channelId: selectedChannelId,
          page: nextPage,
          size: NCLOUD_RECORDING_PAGE_SIZE,
        },
        isNoErrorNotify: true,
      });
      setRecordings(res?.data?.items || []);
      setRecordPage(nextPage);
    } catch (error) {
      setRecordings([]);
      setImportMessage(error?.message || "NCloud 녹화 파일을 조회하지 못했습니다.");
    } finally {
      setRecordingLoading(false);
    }
  };

  const importRecording = async (recording) => {
    if (!selectedChannelId || !selectedSessionIdx || !recording?.record_key) return;
    setImportingKey(recording.provider_record_key);
    setImportMessage("");
    try {
      const res = await _API.post({
        path: `/v1/events/${eventIdx}/media/ncloud-import`,
        data: {
          ...buildScope(),
          channelId: selectedChannelId,
          recordKey: recording.record_key,
          sessionIdx: selectedSessionIdx,
          page: recordPage,
          size: NCLOUD_RECORDING_PAGE_SIZE,
        },
        isNoErrorNotify: true,
      });
      const dedupe = res?.data?.dedupe_result === "duplicate"
        ? res?.data?.session_match_preserved === false
          ? "이미 등록된 녹화본입니다. 기존 연결 세션을 유지했습니다."
          : "이미 등록된 녹화본입니다."
        : "녹화본을 가져왔습니다.";
      setImportMessage(dedupe);
      await loadMedia();
    } catch (error) {
      setImportMessage(error?.message || "NCloud 녹화 가져오기에 실패했습니다.");
    } finally {
      setImportingKey("");
    }
  };

  const getSelectedMatchSession = (mediaIdx) => matchSelections[mediaIdx] || sessions[0]?.session_idx || "";

  const matchRecordingSession = async (item) => {
    const sessionIdx = getSelectedMatchSession(item.media_idx);
    if (!item?.media_idx || !sessionIdx) return;
    setMatchingKey(item.media_idx);
    setMatchMessage("");
    try {
      await _API.post({
        path: `/v1/events/${eventIdx}/media/${item.media_idx}/session-match`,
        data: {
          ...buildScope(),
          sessionIdx,
        },
        isNoErrorNotify: true,
      });
      setMatchMessage("사후 매칭 완료");
      await loadMedia();
    } catch (error) {
      setMatchMessage(error?.message || "세션 사후 매칭에 실패했습니다.");
    } finally {
      setMatchingKey("");
    }
  };

  const runAction = (handler) => (event) => {
    if (event.type === "keydown" && event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    handler();
  };

  useEffect(() => {
    loadImportOptions();
  }, [eventIdx, siteIdx]);

  useEffect(() => {
    loadMedia();
  }, [eventIdx, siteIdx, type, connection, cardState, keyword]);

  const filteredItems = useMemo(() => {
    return items.filter((item) => {
      if (type && item.type !== type) return false;
      if (connection === "LINKED" && item.linked_session_count < 1) return false;
      if (connection === "LINKED_MULTI" && item.linked_session_count < 2) return false;
      if (connection === "UNLINKED" && item.linked_session_count > 0) return false;
      if (cardState && String(item.card_state_code || "").toUpperCase() !== cardState) return false;
      if (keyword && !item.video_title.toLowerCase().includes(keyword.toLowerCase())) return false;
      return true;
    });
  }, [items, type, connection, cardState, keyword]);

  return (
    <MediaLibraryShell data-event-media-library data-api-path={`/v1/events/${eventIdx}/media`}>
      <div className="media-library-header">
        <div>
          <p className="media-library-kicker">이벤트 미디어</p>
          <h1>미디어</h1>
        </div>
        <p className="media-library-count">{loading ? "불러오는 중" : `${filteredItems.length}개 표시`}</p>
      </div>

      <section className="ncloud-import-panel" data-ncloud-recording-import-panel>
        <div className="ncloud-import-header">
          <div>
            <p className="media-library-kicker">NCloud 녹화 가져오기</p>
            <h2>녹화 파일 수동 import</h2>
          </div>
          <Button
            variant="primary"
            type="button"
            data-ncloud-recording-query
            disabled={!selectedChannelId}
            onClick={selectedChannelId ? runAction(() => loadRecordings(0)) : undefined}
          >
            {recordingLoading ? "조회 중" : "조회"}
          </Button>
        </div>
        <div className="ncloud-import-controls">
          <label>
            <span>채널</span>
            <select
              data-ncloud-recording-channel
              value={selectedChannelId}
              onChange={(event) => {
                setSelectedChannelId(event.target.value);
                setRecordPage(0);
                setRecordings([]);
              }}
            >
              {channels.length === 0 && <option value="">채널 없음</option>}
              {channels.map((channel) => (
                <option value={channel.ncloud_channel_id} key={channel.ncloud_channel_id}>
                  {channel.channel_name || channel.ncloud_channel_id}
                </option>
              ))}
            </select>
          </label>
          <label>
            <span>연결 세션</span>
            <select
              data-ncloud-recording-session
              value={selectedSessionIdx}
              onChange={(event) => setSelectedSessionIdx(event.target.value)}
            >
              {sessions.length === 0 && <option value="">세션 없음</option>}
              {sessions.map((session) => (
                <option value={session.session_idx} key={session.session_idx}>
                  {session.session_title || session.session_idx}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="ncloud-recording-list" data-ncloud-recording-list>
          {recordings.length === 0 ? (
            <p>{recordingLoading ? "녹화 파일을 조회하고 있습니다." : "조회된 MP4 녹화 파일이 없습니다."}</p>
          ) : (
            recordings.map((recording) => (
              <div className="ncloud-recording-row" data-ncloud-recording-row key={recording.provider_record_key}>
                <div>
                  <strong>{recording.file_name}</strong>
                  <span>{recording.provider_record_key}</span>
                </div>
                <Button
                  variant="primary"
                  type="button"
                  data-ncloud-recording-import
                  disabled={!selectedSessionIdx}
                  onClick={selectedSessionIdx ? runAction(() => importRecording(recording)) : undefined}
                >
                  {importingKey === recording.provider_record_key ? "가져오는 중" : "가져오기"}
                </Button>
              </div>
            ))
          )}
        </div>
        <div className="ncloud-recording-pagination" data-ncloud-recording-pagination>
          <Button
            variant="outline-secondary"
            type="button"
            data-ncloud-recording-prev
            disabled={recordPage <= 0}
            onClick={recordPage > 0 ? runAction(() => loadRecordings(recordPage - 1)) : undefined}
          >
            이전
          </Button>
          <span data-ncloud-recording-page>{recordPage + 1}</span>
          <Button
            variant="outline-secondary"
            type="button"
            data-ncloud-recording-next
            disabled={recordings.length !== NCLOUD_RECORDING_PAGE_SIZE}
            onClick={recordings.length === NCLOUD_RECORDING_PAGE_SIZE ? runAction(() => loadRecordings(recordPage + 1)) : undefined}
          >
            다음
          </Button>
        </div>
        {importMessage && <p className="media-library-notice" data-ncloud-recording-import-message>{importMessage}</p>}
      </section>

      <div className="media-library-toolbar" data-media-filter-toolbar>
        <label>
          <span>영상 타입</span>
          <select data-media-filter-type value={type} onChange={(event) => setType(event.target.value)}>
            {TYPE_FILTERS.map((item) => (
              <option value={item.value} key={item.value || "all-type"}>
                {item.label}
              </option>
            ))}
          </select>
        </label>
        <label>
          <span>연결 상태</span>
          <select
            data-media-filter-connection
            value={connection}
            onChange={(event) => setConnection(event.target.value)}
          >
            {CONNECTION_FILTERS.map((item) => (
              <option value={item.value} key={item.value || "all-connection"}>
                {item.label}
              </option>
            ))}
          </select>
        </label>
        <label>
          <span>카드 상태</span>
          <select
            data-media-filter-card-state
            value={cardState}
            onChange={(event) => setCardState(event.target.value)}
          >
            {CARD_STATE_FILTERS.map((item) => (
              <option value={item.value} key={item.value || "all-state"}>
                {item.label}
              </option>
            ))}
          </select>
        </label>
        <label className="media-library-search">
          <span>검색</span>
          <input
            data-media-search
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="비디오명 검색"
          />
        </label>
      </div>

	      {filteredItems.length > 0 ? (
	        <div className="media-library-grid" data-media-card-grid>
	          {filteredItems.map((item) => {
	            const cardBody = (
	              <>
	                <div className="media-library-thumb" data-thumbnail-state={item.thumbnail_state}>
	                  <span>{item.type_label}</span>
	                  <span data-thumbnail-state-label>{item.thumbnail_state_label}</span>
	                </div>
	                <div className="media-library-card-body">
	                  <h2>{item.video_title}</h2>
	                  <div className="media-library-meta">
	                    <span>{item.version_kind_label}</span>
	                    {item.edit_version && <span>{item.edit_version}</span>}
	                    <span>{item.card_state}</span>
	                  </div>
	                  <p>
	                    {item.linked_session_count > 0
	                      ? item.linked_sessions_summary.join(", ")
	                      : "연결된 세션 없음"}
	                  </p>
	                  {item.requires_session_match && (
	                    <div className="media-library-session-match">
	                      <select
	                        data-ncloud-session-match-select
	                        value={getSelectedMatchSession(item.media_idx)}
	                        onChange={(event) => setMatchSelections({
	                          ...matchSelections,
	                          [item.media_idx]: event.target.value,
	                        })}
	                      >
	                        {sessions.length === 0 && <option value="">세션 없음</option>}
	                        {sessions.map((session) => (
	                          <option value={session.session_idx} key={`${item.media_idx}-${session.session_idx}`}>
	                            {session.session_title || session.session_idx}
	                          </option>
	                        ))}
	                      </select>
                      <Button
                        variant="primary"
                        type="button"
                        data-ncloud-session-match
                        disabled={!getSelectedMatchSession(item.media_idx)}
                        onClick={getSelectedMatchSession(item.media_idx) ? runAction(() => matchRecordingSession(item)) : undefined}
                      >
                        {matchingKey === item.media_idx ? "매칭 중" : "사후 매칭"}
                      </Button>
	                    </div>
	                  )}
	                </div>
	              </>
	            );
	            return item.requires_session_match ? (
	              <div className="media-library-card" data-media-card key={item.media_idx}>
	                {cardBody}
	              </div>
	            ) : (
	              <Link
	                to={`/event/${eventIdx}/media/${item.media_idx}`}
	                className="media-library-card"
	                data-media-card
	                key={item.media_idx}
	              >
	                {cardBody}
	              </Link>
	            );
	          })}
	        </div>
	      ) : (
        <div className="media-library-empty" data-media-empty-state>
          {mediaError || "등록된 영상이 없습니다."}
        </div>
	      )}
	      {matchMessage && <p className="media-library-notice" data-ncloud-session-match-message>{matchMessage}</p>}

      <nav className="media-library-pagination" data-media-pagination aria-label="미디어 페이지">
        <span>1</span>
      </nav>
    </MediaLibraryShell>
  );
}

const MediaLibraryShell = styled.div`
  min-height: 100%;
  padding: 32px;
  color: var(--color-text-default);
  background: var(--color-surface-page);

  .media-library-header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
  }

  .media-library-kicker,
  .media-library-count,
  .media-library-card p {
    margin: 0;
    font-size: 13px;
    color: var(--color-text-muted);
  }

  h1 {
    margin: 4px 0 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--color-text-heading);
  }

  h2 {
    margin: 4px 0 0;
    font-size: 16px;
    font-weight: 700;
    color: var(--color-text-heading);
  }

  .ncloud-import-panel {
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--radius);
    padding: 16px;
    margin-bottom: 20px;
    background: var(--color-surface-card);
  }

  .ncloud-import-header,
  .ncloud-recording-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .ncloud-import-controls {
    display: grid;
    grid-template-columns: minmax(180px, 1fr) minmax(180px, 1fr);
    gap: 12px;
    margin-top: 14px;
  }

  .ncloud-recording-list {
    display: grid;
    gap: 8px;
    margin-top: 14px;
  }

  .ncloud-recording-list p,
  .media-library-notice {
    margin: 0;
    font-size: 13px;
    color: var(--color-text-muted);
  }

  .ncloud-recording-row {
    min-height: 48px;
    border: 1px solid var(--color-border-soft-alt);
    border-radius: var(--radius);
    padding: 10px 12px;
    background: var(--color-surface-page);
  }

  .ncloud-recording-row div {
    min-width: 0;
  }

  .ncloud-recording-row strong,
  .ncloud-recording-row span {
    display: block;
    overflow-wrap: anywhere;
  }

  .ncloud-recording-row strong {
    font-size: 13px;
    color: var(--color-text-heading);
  }

  .ncloud-recording-row div span {
    margin-top: 4px;
    font-size: 12px;
    color: var(--color-text-muted);
  }

  .media-library-notice {
    margin-top: 10px;
  }

  .media-library-session-match {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    margin-top: 12px;
  }

  .media-library-toolbar {
    display: grid;
    grid-template-columns: repeat(4, minmax(160px, 1fr));
    gap: 12px;
    margin-bottom: 20px;
  }

  label {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    color: var(--color-text-emphasis);
  }

  select,
  input {
    height: 32px;
    border: 1px solid var(--color-border-soft-alt);
    border-radius: var(--radius);
    padding: 0 10px;
    font-size: 13px;
    color: var(--color-text-default);
    background: var(--color-surface-card);
  }

  .media-library-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
  }

  .media-library-card {
    display: block;
    overflow: hidden;
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--radius);
    background: var(--color-surface-card);
    color: inherit;
    text-decoration: none;
  }

  .media-library-thumb {
    aspect-ratio: 16 / 9;
    display: flex;
    gap: 8px;
    align-items: flex-end;
    justify-content: space-between;
    padding: 12px;
    background: var(--color-surface-panel);
  }

  .media-library-thumb span,
  .media-library-meta span,
  .media-library-pagination span {
    display: inline-flex;
    align-items: center;
    min-height: 24px;
    border-radius: var(--radius);
    padding: 0 8px;
    font-size: 12px;
    background: var(--color-brand-soft-bg);
    color: var(--color-brand-soft-text);
  }

  .media-library-card-body {
    padding: 14px;
  }

  .media-library-card h2 {
    margin: 0 0 10px;
    font-size: 14px;
    font-weight: 700;
    color: var(--color-text-heading);
  }

  .media-library-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 10px;
  }

  .media-library-empty {
    border: 1px dashed var(--color-border-dashed-soft);
    border-radius: var(--radius);
    padding: 40px 16px;
    text-align: center;
    font-size: 13px;
    color: var(--color-text-muted);
    background: var(--color-surface-card);
  }

  .media-library-pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  @media (max-width: 767px) {
    padding: 20px;

    .media-library-header {
      align-items: flex-start;
      flex-direction: column;
    }

    .media-library-toolbar {
      grid-template-columns: 1fr;
    }

    .ncloud-import-header,
    .ncloud-recording-row {
      align-items: flex-start;
      flex-direction: column;
    }

    .ncloud-import-controls {
      grid-template-columns: 1fr;
    }
  }
`;
